// extracted by mini-css-extract-plugin
module.exports = {"content-iframes":"protected-route_content-iframes__3jTc1","close":"protected-route_close__2k9ED"};